import { render, staticRenderFns } from "./FormBatch.vue?vue&type=template&id=1115335f&"
import script from "./FormBatch.vue?vue&type=script&lang=js&"
export * from "./FormBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports